module.exports = __webpack_public_path__ + "img/venue1.e56f4a93.png";